import { useFormContext, useWatch } from "react-hook-form";
import ValidatedSelectElement from "./ValidatedSelectElement";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid2";

interface IProps {
    label?: string;
    name: string;
    readOnly: boolean;
    labelSize?: number;
    inputSize?: number;
    alwaysShow?: boolean;
    options: { id: string | number | boolean | null; label: string }[] | null;
}

export default function RenderSelectField({ label, name, readOnly, labelSize = 8, inputSize = 4, alwaysShow = false, options, }: IProps) {
    const { control } = useFormContext();
    const value = useWatch({ control, name });

    if (!alwaysShow && readOnly && (value === null || value === undefined || options == null)) {
        return null;
    }

    const safeOptions = options ?? [];

    return (
        <Grid container size={12}>
            {label && (
                <Grid size={labelSize} sx={{ display: 'flex', alignItems: 'center' }}>
                    <Typography variant="body1">{label}</Typography>
                </Grid>
            )}
            <Grid size={label == null ? 12 : inputSize}>
                <ValidatedSelectElement name={name} readOnly={readOnly} options={safeOptions} />
            </Grid>
        </Grid>
    );
}
